import { useEffect, useState } from 'react';
import useXForm from './useXForm';
/**
 * This hook returns a field control object that provides the ability to change the field's state.
 *
 * @param fieldName The name of the field you want to control
 * @returns FieldControl
 */
const useField = (fieldName) => {
    const { actors } = useXForm();
    const [, actorRef] = Object.entries(actors).find(([name]) => name === fieldName) || [];
    const [fieldMachineSubscription, setFieldMachineSubscription] = useState();
    if (!actorRef) {
        throw new Error(`Field name of "${fieldName}" not found`);
    }
    const snapshot = actorRef.getSnapshot();
    const [isDisabled, setIsDisabled] = useState(snapshot.matches('mutable.disabled'));
    const [isEnabled, setIsEnabled] = useState(snapshot.matches('mutable.enabled'));
    const [isReadonly, setIsReadonly] = useState(snapshot.matches('mutable.readonly'));
    const [error, setError] = useState(snapshot.context.error);
    const [value, setValue] = useState(snapshot.context.value);
    useEffect(() => {
        const subscription = actorRef.subscribe((state) => {
            setIsDisabled(state.matches('mutable.disabled'));
            setIsEnabled(state.matches('mutable.enabled'));
            setIsReadonly(state.matches('mutable.readonly'));
            setValue(state.context.value);
            setError(state.context.error);
        });
        if (fieldMachineSubscription) {
            fieldMachineSubscription.unsubscribe();
        }
        setFieldMachineSubscription(subscription);
        return subscription.unsubscribe;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [actorRef]);
    return {
        disable: () => actorRef.send('DISABLE'),
        enable: () => actorRef.send('ENABLE'),
        error,
        blur: () => actorRef.send({ type: 'BLUR' }),
        setValue: (newValue) => actorRef.send({
            type: 'CHANGE',
            value: newValue
        }),
        focus: () => actorRef.send({ type: 'FOCUS' }),
        isDisabled,
        isEnabled,
        isReadonly,
        name: snapshot.context.name,
        readonly: () => actorRef.send('READONLY'),
        reset: () => actorRef.send({ type: 'RESET' }),
        value
    };
};
export default useField;
